<template>
  <div>
    <vs-table :data="antiSanctions">
      <template slot="thead">
        <vs-th>ID</vs-th>
        <vs-th>Title</vs-th>
        <vs-th>Username</vs-th>
        <vs-th>Domain</vs-th>
        <vs-th>کل ترافیک</vs-th>
        <vs-th>ترافیک مصرف شده</vs-th>
        <vs-th>Expired At</vs-th>
        <vs-th>Created At</vs-th>
        <vs-th>Options</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="sanction in data" :key="sanction.id">
          <vs-td>{{ sanction.id }}</vs-td>
          <vs-td>{{ sanction.title }}</vs-td>
          <vs-td>{{ sanction.username }}</vs-td>
          <vs-td>{{ sanction.domain }}</vs-td>
          <vs-td>{{ sanction.total_traffic }}</vs-td>
          <vs-td>{{ sanction.usage_percent }}</vs-td>
          <vs-td>{{ sanction.expired_at }}</vs-td>
          <vs-td>{{ sanction.created_at }}</vs-td>
          <vs-td class="">
            <vs-button @click="renewService(sanction.id)" color="primary">تمدید</vs-button>
            <vs-button @click="deleteService(sanction.id)" color="danger">حذف</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      antiSanctions: []
    };
  },
  async mounted() {
    this.fetchAntiSanctions();
  },
  methods: {
    async fetchAntiSanctions() {
        console.log(`admin/anti/sanction?filter&page&user_id=${this.userId}&with_deleted=0`);
        
      try {
        const response = await this.$http.get(`admin/anti/sanction?filter&page&user_id=${this.$route.query.id || this.userId}&with_deleted=0`);
        if (response.data.status) {
        console.log("TESTESTESTES: ", response.data.params.data);
          this.antiSanctions = response.data.params.data;
        }
      } catch (error) {
        this.$vs.notify({ text: 'Error fetching anti sanctions', color: 'danger' });
      }
    },
    async renewService(id) {
      try {
        await this.$http.put(`admin/anti/sanction/${id}/renew`);
        this.fetchAntiSanctions(); // Refresh the list after renewing
        this.$vs.notify({ text: 'AntiSanction renewed successfully', color: 'success' });
      } catch (error) {
        this.$vs.notify({ text: 'Error renewing anti sanction', color: 'danger' });
      }
    },
    async deleteService(id) {
      try {
        await this.$http.delete(`admin/anti/sanction/${id}`);
        this.fetchAntiSanctions(); // Refresh the list after deleting
        this.$vs.notify({ text: 'AntiSanction deleted successfully', color: 'success' });
      } catch (error) {
        this.$vs.notify({ text: 'Error deleting anti sanction', color: 'danger' });
      }
    }
  }
};
</script>
